'use strict';

var Model = require('base/Colido.Model');

/**
 * Model for a modal window
 *
 * @category   Model
 * @module     global
 * @copyright  Copyright (c) 2016, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@h-m.io>
 */
var ModalModel = Model.extend({});

module.exports = ModalModel;